import { connect } from "react-redux";
import UpdateTeamTemplateSizeModal from "./UpdateTeamTemplateSizeModal";
import { updateTeamTemplateSize } from "state/entities/teamTemplateSizes/teamTemplateSizesActions";
import { isProcessingTeamTemplateSizesSelector } from "state/entities/teamTemplateSizes/teamTemplateSizesSelectors";

const mapStateToProps = (state: any) => ({
  teamId: state.ui.currentTeam?.id,
  isProcessing: isProcessingTeamTemplateSizesSelector(state)
});

const mapDispatchToProps = (dispatch: any) => ({
  updateTeamTemplateSize: (args: any) => dispatch(updateTeamTemplateSize(args))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UpdateTeamTemplateSizeModal);
